import { EAutofillType } from './types';

export const DEFAULT_MIN_BUDGET_MASS_AUTOFILL = 500;
export const DEFAULT_MIN_BUDGET = 1000;
export const MIN_SUM = 1;

export enum EFieldName {
    Autofill = 'autofill',
    MassAutofill = 'massAutofill'
}

export const AUTOFILL_FORM_DEFAULT_PROPS = {
    type       : EAutofillType.EDIT,
    showTooltip: true,
    buttonText : ''
};

export const DEFAULT_FORM_AUTOFILL_SOURCE = {
    balance: false,
    net    : true
};
export const DEFAULT_FORM_AUTOFILL_SOURCE_UNIFIED = {
    balance        : false,
    net            : false,
    unified_account: true
};

export const DEFAULT_FORM_AUTOFILL_VALUES = {
    autofill: {
        betMin      : DEFAULT_MIN_BUDGET,
        betSum      : DEFAULT_MIN_BUDGET,
        isDailyLimit: true,
        limit       : 1,
        endDate     : undefined,
        isEnable    : false,
        special     : undefined,
        source      : {
            ...DEFAULT_FORM_AUTOFILL_SOURCE
        }
    }
};

export const DEFAULT_FORM_AUTOFILL_VALUES_UNIFIED = {
    autofill: {
        ...DEFAULT_FORM_AUTOFILL_VALUES.autofill,
        source: {
            ...DEFAULT_FORM_AUTOFILL_SOURCE_UNIFIED
        }
    }
};

export const DEFAULT_FORM_MASS_AUTOFILL_VALUES = {
    massAutofill: {
        ...DEFAULT_FORM_AUTOFILL_VALUES.autofill,
        betMin  : DEFAULT_MIN_BUDGET_MASS_AUTOFILL,
        isEnable: true,
        source  : {
            balance: true,
            net    : true
        }
    }
};

export const DEFAULT_FORM_MASS_AUTOFILL_VALUES_UNIFIED = {
    massAutofill: {
        ...DEFAULT_FORM_AUTOFILL_VALUES_UNIFIED.autofill,
        betMin  : DEFAULT_MIN_BUDGET_MASS_AUTOFILL,
        isEnable: true
    }
};
